import React from 'react';

export function Button({
  children,
  variant = 'primary',
  size = 'md',
  type = 'button',
  href,
  disabled = false,
  iconLeft = null,
  iconRight = null,
  fullWidth = false,
  style = {},
  onClick,
  ...rest
}) {
  const sizes = {
    sm: { padding: '10px 22px', fontSize: '14px' },
    md: { padding: '14px 34px', fontSize: '16px' },
    lg: { padding: '17px 44px', fontSize: '18px' },
  };

  const variants = {
    primary: {
      background: 'var(--color-primary)',
      color: 'var(--white)',
      border: '2px solid transparent',
      boxShadow: 'var(--shadow-cta)',
    },
    secondary: {
      background: 'var(--color-secondary)',
      color: 'var(--white)',
      border: '2px solid transparent',
      boxShadow: '0 4px 20px rgba(26,54,93,0.30)',
    },
    accent: {
      background: 'var(--color-accent)',
      color: 'var(--white)',
      border: '2px solid transparent',
      boxShadow: '0 4px 20px rgba(139,115,85,0.28)',
    },
    outline: {
      background: 'transparent',
      color: 'var(--color-primary)',
      border: '2px solid var(--color-primary)',
      boxShadow: 'none',
    },
    ghost: {
      background: 'transparent',
      color: 'var(--text-strong)',
      border: '2px solid transparent',
      boxShadow: 'none',
    },
  };

  const base = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
    width: fullWidth ? '100%' : 'auto',
    fontFamily: 'var(--font-ui)',
    fontWeight: 600,
    lineHeight: 1,
    textDecoration: 'none',
    borderRadius: 'var(--radius-pill)',
    cursor: disabled ? 'not-allowed' : 'pointer',
    opacity: disabled ? 0.5 : 1,
    transition: 'transform var(--dur) var(--ease), background var(--dur) var(--ease), box-shadow var(--dur) var(--ease)',
    whiteSpace: 'nowrap',
    ...sizes[size],
    ...variants[variant],
    ...style,
  };

  const hoverBg = {
    primary: 'var(--color-primary-hover)',
    secondary: 'var(--color-secondary-hover)',
    accent: 'var(--tan-700)',
    outline: 'var(--color-primary-soft)',
    ghost: 'var(--color-primary-soft)',
  };

  const onEnter = (e) => {
    if (disabled) return;
    e.currentTarget.style.transform = 'translateY(-3px)';
    e.currentTarget.style.background = hoverBg[variant];
    if (variant === 'ghost' || variant === 'outline') e.currentTarget.style.color = 'var(--color-primary)';
  };
  const onLeave = (e) => {
    if (disabled) return;
    e.currentTarget.style.transform = 'translateY(0)';
    e.currentTarget.style.background = variants[variant].background;
    e.currentTarget.style.color = variants[variant].color;
  };

  const content = (
    <>
      {iconLeft}
      {children}
      {iconRight}
    </>
  );

  if (href && !disabled) {
    return (
      <a href={href} style={base} onMouseEnter={onEnter} onMouseLeave={onLeave} onClick={onClick} {...rest}>
        {content}
      </a>
    );
  }

  return (
    <button type={type} disabled={disabled} style={base} onMouseEnter={onEnter} onMouseLeave={onLeave} onClick={onClick} {...rest}>
      {content}
    </button>
  );
}
